import React from 'react';
import {
  Box,
  Scrollable,
  ParagraphText,
  HeadingText,
} from '@leagueplatform/genesis-core';
import { Accordion } from '#components/accordion/accordion.tsx';
import { accordionStyleOverrides } from './styles';
import type { GDSVideoProps } from './video';

export const Transcript = ({
  transcript,
}: {
  transcript: GDSVideoProps['transcript'];
}) => {
  const { content, buttonLabel, heading } = transcript || {};

  if (!content || !buttonLabel || !heading) return null;

  return (
    <Box
      css={{
        paddingBlock: '$oneAndHalf',
        borderBlockEnd: '$borderWidths$thin $onSurfaceBorderDefault solid',
      }}
    >
      <Accordion
        heading={buttonLabel}
        className="GDS-video-transcript"
        css={accordionStyleOverrides}
      >
        <Scrollable
          height="100%"
          css={{
            padding: '$half',
          }}
        >
          <HeadingText level="4" size="xs" css={{ marginBlockEnd: '$one' }}>
            {heading}
          </HeadingText>
          <ParagraphText
            css={{
              // Break lines at newline characters
              whiteSpace: 'pre-line',
              // Label typography for text directly in the element (plain text)
              typography: '$label',
              // Add spacing between paragraphs
              p: { marginBlockEnd: '$threeQuarters' },
              // Label font size for all children elements (rich text)
              '*': { fontSize: '$label' },
            }}
          >
            {content}
          </ParagraphText>
        </Scrollable>
      </Accordion>
    </Box>
  );
};
